<template>
  <div>
    <div id="banner">
      <img
        :src="bannerLembaga.desktop"
        class="img-fluid w-100 background-image web-version">
      <img
        :src="bannerLembaga.mobile"
        class="img-fluid w-100 background-image mobile-version">
      <div class="container m-auto">
        <div class="row">
          <div class="col">
            <h1 class="hind-guntur-semi-bold opsi-lembaga m-auto">Pilihan Lembaga</h1>
          </div>
        </div>
      </div>
    </div>
    <template-loading v-if="isLoading || !$route.params"></template-loading>
    <div
      class="container-fluid lembaga-wrapper"
      v-else
    >
      <div class="row my-5 justify-content-center">
        <div class="col-lg-7 col-12">
          <!-- desktop search bard -->
          <form
            class="search-bar-web"
            @submit.prevent="searchLembaga()"
          >
            <select
              class="gotham-book select-search"
              v-model="selectedType"
            >
              <!-- <option value="all">Semua</option> -->
              <option
                v-for="(type, i) in filteredRefs"
                :key="i"
                :value="type.value"
              >{{type.label}}</option>
            </select>
            <input
              v-model="keyword"
              type="text"
              class="input-search"
              placeholder="Cari lembaga"
              @change="!keyword && fetchList()"
            >
            <img
              src="../../assets/icons/icon_search.png"
              @click.prevent="searchLembaga()"
            >
          </form>

          <!-- mobile search bar -->
          <form
            class="search-bar-mobile"
            @submit.prevent="searchLembaga()"
          >
            <input
              v-model="keyword"
              type="text"
              class="input-search"
              placeholder="Cari lembaga"
              @change="!keyword && fetchList()"
            >
            <img
              src="../../assets/icons/icon_search.png"
              @click.prevent="searchLembaga()"
            >
          </form>
          <select
            class="gotham-book select-search-mobile mobile-version mt-3 p-2"
            v-model="selectedType"
          >
            <option
              v-for="(type, i) in filteredRefs"
              :key="i"
              :value="type.value"
            >{{type.label}}</option>
          </select>
        </div>
      </div>
      <div v-if="!institutions.length" class="row">
        <div class="col text-center">
          <img src="../../assets/images/emptystate.svg">
          <h2 class="open-sans text-center mb-5 mt-3 not-found">
            Jenis Lembaga <b>{{typeLabel}}</b> tidak ditemukan
          </h2>
        </div>
      </div>
      <div
        class="row d-flex justify-content-center"
        v-else
      >
        <div
          v-for="(institution, i) in institutions"
          :key="i"
          class="col-md-3 col-lg-2 col-6 card-wrapper"
        >
          <router-link :to="`/mitra/${institution.slug}`">
            <institution-card
              :logoSrc="institution.logo"
              :name="institution.name"
              :type="institution.type_label"
            ></institution-card>
          </router-link>
        </div>
      </div>
      <div
        class="row mb-5"
        v-if="nextUrl"
      >
        <div class="col text-center">
          <s-button
            variant="primary"
            cluster="k"
            @click.prevent="loadMore()"
          >Tampilkan Lainnya</s-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateLoading from '@/components/Table/TemplateLoading'
import Image from '@/assets/images/index'
import InstitutionCard from '@/components/lembaga/InstitutionCard'

export default {
  components: {
    TemplateLoading,
    InstitutionCard
  },
  data () {
    return {
      dukungan: Image.dukunganmedia,
      bannerLembaga: {
        desktop: Image.bannerLembagaDesktop,
        mobile: Image.bannerLembagaMobile
      },
      selectedType: '',
      keyword: '',
      isLoading: true,
      isLoadMore: false
    }
  },
  computed: {
    typeGroups () {
      return this.$store.state.institutionList.typeGroups
    },
    typeRefs () {
      return this.$store.state.institutionList.typeRefs
    },
    filteredRefs () {
      const activePath = this.$route.path.split('/').reverse()[0]
      if (activePath !== 'all') {
        const activeGroup = this.typeGroups.filter(group => Object.keys(group)[0].trim().toLowerCase() === activePath.trim().toLowerCase())[0]
        return this.typeRefs.filter(type => activeGroup[activePath].includes(type.label))
      } else {
        return [{ label: 'Semua', value: '' }, ...this.typeRefs]
      }
    },
    institutions () {
      return this.$store.state.institutionList.institutions.filter(inst =>
        ['KARIERMU', 'PRAKERJA', 'KAMPUS_MERDEKA'].includes(inst.business_unit_label)
      )
    },
    nextUrl () {
      return this.$store.state.institutionList.nextUrl
    },
    typeLabel () {
      const activeLabel = this.filteredRefs.filter(type => type.value === this.selectedType)
      return activeLabel.length ? activeLabel[0].label : null
    }
  },
  methods: {
    async loadMore () {
      this.isLoadMore = true
      await this.$store.dispatch('institutionList/fetchInstitutionList', { nextUrl: this.nextUrl })
      this.isLoadMore = false
    },
    async fetchList () {
      if (this.keyword) {
        this.searchLembaga()
      } else {
        this.isLoading = true
        await this.$store.dispatch('institutionList/fetchInstitutionList', { type: this.selectedType })
        this.isLoading = false
      }
    },
    async searchLembaga () {
      this.isLoading = true
      await this.$store.dispatch('institutionList/fetchInstitutionList', { type: this.selectedType, lembaga: this.keyword })
      this.isLoading = false
    }
  },
  watch: {
    filteredRefs () {
      this.selectedType = this.filteredRefs[0].value
      this.fetchList()
    },
    selectedType (newType) {
      this.fetchList()
    }
  },
  created () {
    this.$store.dispatch('institutionList/fetchTypeReferences')
    this.isLoading = false
  },
  head: {
    title: 'Daftar Mitra Lembaga | Karier.mu'
  }
}
</script>

<style scoped>
#banner {
  display: flex;
  align-items: center;
  min-height: 370px;
  position: relative;
  overflow: hidden;
}

.opsi-lembaga {
  min-width: 422px;
  min-height: 45px;
  font-weight: bold;
  font-size: 50px;
  line-height: 45px;
  text-align: center;
  color: #ffffff;
}

.h1-mitra {
  font-weight: bold;
  font-size: 2vw;
  line-height: 45px;
  text-align: center;
  color: #000000;
}

.web-version {
  display: block;
}

.mobile-version {
  display: none;
}

.background-image {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 100% 0;
}

.lembaga-wrapper {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

p {
  margin-bottom: 0px;
}

a {
  text-decoration: none;
  color: inherit;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
}

.input-wrapper {
  width: 40%;
}

.button-search {
  background-color: white;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-color: #e0e0e0;
  border-left: none;
}

.icon-search {
  color: black;
  font-size: 14px;
}

.navigation-list-wrapper {
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: center;
}

.button-list {
  background-color: #ffffff;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  border: none;
  margin: 0px 15px;
  border-bottom-color: #ffffff;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.button-list-active {
  background-color: #ffffff;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  border: none;
  margin: 0px 15px;
  color: #3498db;
  font-style: normal;
  text-decoration: underline;
}

.button-list:hover {
  cursor: pointer;
  color: #3498db;
  font-weight: bold;
  font-style: normal;
  border-bottom-color: #3498db;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.button-list:focus {
  outline-color: white;
  outline-style: none;
}

.card-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 50px;
}

.content-card-wrapper {
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.pagination {
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
}

.pagination-button {
  margin: 0px 10px;
  background-color: #ffc429;
  border-radius: 50%;
  padding: 5px 12px;
}

.load-more {
  border-radius: 50px;
  padding: 0px 20px;
  padding-top: 12px;
  padding-bottom: 8px;
  background-color: #ffc429;
  border: 1px solid #ffc429;
  font-family: "hind_guntursemibold";
  font-style: normal;
  font-weight: bold;
}

.load-more:hover {
  background-color: #ffffff;
  color: #ffc429;
  border: 1px solid #ffc429;
}

.bottom-banner {
  display: flex;
  background-color: #f9f9f9;
}

.left-side {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 0px;
  padding-left: 150px;
  padding-right: 50px;
}

.right-side {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0px;
}

.description-detail {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}

.download-description {
  padding-top: 20px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  padding-bottom: 20px;
}

.loading-info {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}

.detail-information {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.3);
}

.navigation-list-wrapper-small {
  display: none;
}

.search-bar-mobile {
  display: none;
}

.search-bar-web {
  display: flex;
  border: solid 1px #e0e0e0;
  border-radius: 20px;
  width: 100%;
  position: relative;
  height: 35px;
  margin: auto;
}

.search-bar-web img {
  height: 50%;
  position: absolute;
  top: 9px;
  right: 20px;
  cursor: pointer;
}

.select-search {
  background-image: linear-gradient(45deg, transparent 50%, #e0e0e0 60%),
    linear-gradient(135deg, #e0e0e0 40%, transparent 50%) !important;
  background-position: calc(105% - 25px) 11px, calc(105% - 15px) 11px, 100% 0;
  background-size: 10px 10px, 10px 10px;
  background-repeat: no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
  color: rgba(0, 0, 0, 0.7);
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border: 0;
  text-indent: 5px;
  min-width: 171px;
  padding-left: 10px;
  padding-right: 10px;
  outline: none;
  height: 100%;
  line-height: 15px;
  font-size: 14px;
}

.input-search {
  border: 0;
  border-left: solid 1px #e0e0e0;
  width: 100%;
  text-indent: 10px;
  margin-right: 15px;
  font-size: 14px;
}

.input-search::placeholder {
  color: rgba(0, 0, 0, 0.3);
}

@media screen and (max-width: 1280px) {
  .content-card-wrapper {
    width: 100%;
  }
}

@media screen and (max-width: 970px) {
  .button-list {
    margin: 0px 15px;
  }

  .button-list-active {
    margin: 0px 15px;
  }

  .input-wrapper {
    width: 60%;
  }
}

@media screen and (max-width: 890px) {
  .left-side {
    padding-left: 100px;
  }

  .content-card-wrapper {
    width: 100%;
  }
}

@media screen and (max-width: 720px) {
  .button-list {
    margin: 0px 2.5%;
  }

  .button-list-active {
    margin: 0px 2.5%;
  }

  .image-dukungan {
    width: 90%;
    height: 90%;
  }

  .content-card-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;
  }

  .left-side {
    width: 100%;
    text-align: center;
    align-items: center;
    padding: 16px;
  }

  .right-side {
    width: 100%;
    padding: 16px;
    padding-bottom: 77px;
  }

  .bottom-banner {
    display: block;
    background-color: #f9f9f9;
    padding-right: 16px;
    padding-left: 16px;
  }
}

@media screen and (max-width: 500px) {
  .navigation-list-wrapper {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 80%;
  }

  .button-list {
    margin-bottom: 10px;
  }

  .input-wrapper {
    width: 80%;
  }
}

@media screen and (max-width: 426px) {
  #banner {
    display: flex;
    align-items: center;
    min-height: 290px;
    height: 290px;
    position: relative;
    overflow: hidden;
  }

  .not-found {
    font-size: 17px;
  }

  .opsi-lembaga {
    min-width: 211px;
    min-height: 45px;
    font-weight: bold;
    font-size: 25px;
    line-height: 45px;
    text-align: center;
    color: #ffffff;
  }

  .card-wrapper {
    padding: 0px !important;
  }

  .web-version {
    display: none;
  }

  .mobile-version {
    display: block;
    max-height: 411px;
  }

  .sub-header-text {
    font-size: 14px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.7);
  }

  .sub-question-gojek {
    margin-top: 8px;
    margin-bottom: 0px !important;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
  }

  #tag-not-found {
    font-size: 5vw;
  }

  .h1-mitra {
    font-size: 5vw;
    line-height: 30px;
  }

  .mitra-info {
    background-color: #f9f9f9;
    width: 100%;
    padding: 20px 0px;
  }

  .search-bar-web {
    display: none;
  }

  .search-bar-mobile {
    width: 100%;
    height: 35px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 20px;
    display: block;
    position: relative;
  }

  .search-bar-mobile img {
    height: 50%;
    position: absolute;
    top: 9px;
    right: 20px;
    cursor: pointer;
  }

  .input-search {
    border: 0;
    width: 90%;
    height: 100%;
    text-indent: 10px;
    margin-left: 15px;
    font-size: 14px;
  }

  .input-search::placeholder {
    color: rgba(0, 0, 0, 0.3);
  }

  .select-search-mobile {
    width: 100%;
    height: 35px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 17.5px;
    padding-left: 15px !important;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    color: #4f4f4f;
    background-image: linear-gradient(45deg, transparent 50%, #e0e0e0 60%),
      linear-gradient(135deg, #e0e0e0 40%, transparent 50%) !important;
    background-position: calc(105% - 40px) 11px, calc(105% - 30px) 11px, 100% 0;
    background-size: 10px 10px, 10px 10px;
    background-repeat: no-repeat;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: rgba(0, 0, 0, 0.7);
  }

  .lembaga-wrapper {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .navigation-list-wrapper {
    display: none;
  }

  .navigation-list-wrapper-small {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 80%;
    margin-top: 25px;
  }

  .top-menu-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .bottom-menu-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .bottom-menu-inside {
    display: flex;
    width: 60%;
    justify-content: space-between;
  }
}

@media screen and (max-width: 321px) {
  .bottom-menu-inside {
    width: 70%;
  }
}
</style>

